<template>
    <section v-if="shade" class="infoTeinte" :class="{ lastShade: lastShade }">
        <div
            class="uppercase"
            v-if="shade && shade.properties.hasOwnProperty('colors')"
            :style="'border: 2px solid ' + shade.properties.colors.color.value + ';'"
        >
            <div
                v-if="shade.properties.hasOwnProperty('colors')"
                class="shadeBack"
                :style="'background:' + shade.properties.colors.color.value + ';'"
            >
                <span class="shadeName"
                    ><span v-if="shade.properties.hasOwnProperty('number')">{{ shade.properties.number.numb1.value }} - </span>{{ shade.name }}</span
                >
                <button class="btn editShade rel center" @click="editShade(shade.id);" v-if="hasAccessUpdate('shade_manager')">
                    {{ $t("shades.edit") }}
                </button>
            </div>
            <div class="campaign">
                <div class="flexContainer">
                    <p>{{ $t("shades.color") }} :</p>
                    <p class="labelColor bold" v-if="shade.properties.hasOwnProperty('colors')">&nbsp;{{ shade.properties.colors.color.value }}</p>
                </div>
                <div class="flexContainer">
                    <p>{{ $t("shades.campaignL") }} :</p>
                    <p class="labelColor bold">&nbsp;{{ shade.CampaignLaunch }}</p>
                </div>
                <div class="flexContainer">
                    <p v-if="shade.campaignDiscontinued !== null">Discontinue :</p>
                    <p class="label" v-if="shade.campaignDiscontinued !== null">&nbsp;{{ shade.campaignDiscontinued.name }}</p>
                </div>

                <p>zones :</p>
                <div v-for="(zone, key) in shade.shadeZones.zones" :key="key" class="flexContainer zoneCampaign">
                    <span>{{ key }} : </span>
                    <span v-if="zone.campaignLaunch"
                        >{{ zone.campaignLaunch.name }} <span v-if="zone.campaignDiscontinued !== null">- {{ zone.campaignDiscontinued.name }}</span
                        ><span v-if="zone.campaignDiscontinued === null"> - NOT DISCONTINUED</span></span
                    >
                </div>
                <div>
                    <p>
                        {{ $t("planoList.created") }} {{ shade.createdAt }} {{ $t("planoList.by") }} {{ shade.createdUser.firstname }}
                        {{ shade.createdUser.lastname }}
                    </p>
                    <p>
                        {{ $t("planoList.modified") }}: {{ shade.modifiedDate }} {{ $t("planoList.by") }} {{ shade.modifiedUser.firstname }}
                        {{ shade.modifiedUser.lastname }}
                    </p>
                </div>
            </div>
            <div
                class="footerHover"
                v-if="shade.properties.hasOwnProperty('colors')"
                :style="'background:' + shade.properties.colors.color.value + ';'"
            ></div>
        </div>

        <div class="uppercase" v-if="shade && shade.properties.hasOwnProperty('colors') === false" style="border: 2px solid #FFF;">
            <div class="shadeBack" style="background: #FFF;">
                <span class="shadeName"
                    ><span v-if="shade.properties.hasOwnProperty('number')">{{ shade.properties.number.numb1.value }} - </span>{{ shade.name }}</span
                >
                <button class="btn editShade rel center" @click="editShade(shade.id);" v-if="hasAccessUpdate('shade_manager')">
                    {{ $t("shades.edit") }}
                </button>
            </div>
            <div class="campaign">
                <div class="flexContainer">
                    <p>COLOR :</p>
                    <p class="labelColor bold">&nbsp;NO COLOR</p>
                </div>
                <div class="flexContainer">
                    <p>Campagne de lancement :</p>
                    <p class="labelColor bold">&nbsp;{{ shade.CampaignLaunch }}</p>
                </div>
                <div class="flexContainer">
                    <p v-if="shade.campaignDiscontinued !== null">Discontinue :</p>
                    <p class="label" v-if="shade.campaignDiscontinued !== null">&nbsp;{{ shade.campaignDiscontinued.name }}</p>
                </div>

                <p>zones :</p>
                <div v-for="(zone, key) in shade.shadeZone.zones" :key="key" class="flexContainer zoneCampaign">
                    <span>{{ key }} : </span>
                    <span v-if="zone.campaignLaunch"
                        >{{ zone.campaignLaunch.name }} <span v-if="zone.campaignDiscontinued !== null">- {{ zone.campaignDiscontinued.name }}</span>
                        <span v-if="zone.campaignDiscontinued === null"> - NOT DISCONTINUED</span>
                    </span>
                </div>
            </div>
            <div class="footerHover" style="background: #FFF;"></div>
        </div>
    </section>
</template>

<script>
import { bus } from "../../main";
export default {
    name: "ShadeHover",
    props: ["shade", "index"],
    computed: {
        lastShade() {
            return (this.index + 1) % 6 ? false : true;
        }
    },
    methods: {
        editShade(shadeId) {
            bus.$emit("editShade", shadeId);
        }
    },
    created() {}
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes";

.editShade {
    left: 85px;
    top: 18px;
    margin-left: 30%;
}

.whenCertified {
    font-family: Roboto;
    font-size: 14px;
    margin-left: 65px;
    margin-top: -47px;
}

.whenNotCertified {
    text-transform: lowercase;
    margin-left: 65px;
    font-family: Roboto;
    font-size: 14px;
    margin-top: 10px;
}

.campaign {
    padding: 10px;
    font-size: 12px;
}

.footerHover {
    height: 3px;
}

.zoneCampaign {
    margin-top: 10px;
    font-family: Roboto;
    font-weight: bold;
}

.label {
    font-family: Roboto;
    font-weight: bold;
    font-size: 12px;
}

.shadeName {
    font-family: "Oswald", Sans-Serif;
    color: #fff;
    font-size: 20px;
    padding-left: 10px;
    display: block;
    padding-top: 4px;
}

.shadeBack {
    width: 100%;
    height: 30px;
}

.infoTeinte {
    border: 4px pink solid;
    position: absolute;
    top: -60px;
    left: 60px;
    width: 300px;
    height: auto;
    @extend %second-bloc;
    z-index: 50;
    &.lastShade {
        top: -60px;
        left: -310px;
    }
}
</style>



// WEBPACK FOOTER //
// ShadeHover.vue?bd3d6466